"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var localStyles = require("./BusinessTools.scss");
var ui_components_1 = require("@idp/ui-components");
var RemoveModalContent_1 = require("../shared/RemoveModalContent");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
var CartConfiguration_scss_1 = require("../../CartConfigurationContainer/CartConfiguration.scss");
var utils_1 = require("@idp/ui-components/utils");
var PriceContainerProps_1 = require("@idp/ui-components/components/cards/PriceContainer/PriceContainerProps");
var Api_1 = require("../../../api/Api");
var ReportingService_1 = require("../../../api/ReportingService");
var StateProvider_1 = require("../../../api/StateProvider");
var Utils = require("../../../utils/UtilityFunctions");
var CartViewPanelProps_1 = require("../../panels/CartViewPanel/CartViewPanelProps");
var CartViewPanel_1 = require("../../panels/CartViewPanel");
var cartUtils = require("../../../utils/CartUtilFunctions");
var cms_integration_1 = require("@idp/cms-integration");
var Cart_cms_1 = require("../../../cms/Cart.cms");
var BroadbandCart_cms_1 = require("../BroadbandCart/BroadbandCart.cms");
var routables_1 = require("@idp/routables");
var BusinessTools = /** @class */ (function (_super) {
    __extends(BusinessTools, _super);
    function BusinessTools(props) {
        var _this = _super.call(this, props) || this;
        _this.numberOfKeys = [];
        _this.dueTodayPrice = 0;
        _this.state = {
            isRemoveModalOpen: false,
        };
        _this.initializeEvents();
        _this.toggleRemoveModal = _this.toggleRemoveModal.bind(_this);
        _this.onCartRemove = _this.onCartRemove.bind(_this);
        _this.initializeProps = _this.initializeProps.bind(_this);
        _this.redirectToBuyFlow = _this.redirectToBuyFlow.bind(_this);
        _this.api = new Api_1.default();
        _this.reportingService = new ReportingService_1.default();
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        return _this;
    }
    BusinessTools.prototype.initializeProps = function () {
        var _a, _b;
        this.payload = Utils.getCartResp();
        if (this.payload) {
            this.businessCartLosgs = Object.values(this.payload.businessAppCart.losgs);
            this.cartMetaData = this.payload.metadata.metadata.businessAppsCartMetadata;
            this.dueTodayPrice = (_b = (_a = this.payload) === null || _a === void 0 ? void 0 : _a.orderPriceInfo) === null || _b === void 0 ? void 0 : _b.dueToday;
        }
    };
    BusinessTools.prototype.render = function () {
        var _this = this;
        this.initializeProps();
        var lineItems;
        var lineItemsData = [];
        if (this.businessCartLosgs) {
            this.businessCartLosgs.forEach(function (losg) {
                _this.numberOfKeys.push(losg);
                lineItemsData.push((losg.lineItems));
            });
        }
        lineItems = Object.assign({}, lineItemsData[0], lineItemsData[1]);
        var lineItem;
        var businessPackage = [];
        var cmsData = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content;
        if (cmsData.broadbandCart && cmsData.broadbandCart.cartSummary) {
            this.cmsContent = cmsData.broadbandCart.cartSummary;
        }
        else {
            this.cmsContent = new BroadbandCart_cms_1.BroadbandCartCms();
        }
        var businessStandaloneStyle = (this.props.data.isStandaloneBusiness)
            ? localStyles.standaloneBusinessClass : '';
        var businessBundleStyle = (!this.props.data.isStandaloneBusiness)
            ? localStyles.businessCartHeader : '';
        if (lineItems) {
            Object.keys(lineItems).forEach(function (key) {
                lineItem = lineItems[key];
                businessPackage.push(lineItem);
            });
        }
        return (React.createElement("div", { className: localStyles.businesscart },
            React.createElement("div", { className: !this.props.data.isStandaloneBusiness ?
                    localStyles.solidLineLightGray : '' }),
            React.createElement("div", { className: businessBundleStyle },
                React.createElement("div", null,
                    React.createElement(CartViewPanel_1.default, { testId: utils_1.default('Business', 'CartViewPanel', 'LineItem'), data: this.buildCartViewPanelData(), events: this.cartViewEvents, options: {
                            commonPromotionText: '',
                            isPromoTextApplicable: false,
                            isRemoveAllButtonApplicable: true,
                            planType: CartViewPanelProps_1.PlanType.BUSINESS_TOOLS,
                        } }),
                    React.createElement(ui_components_1.Modal, { testId: utils_1.default('Business', 'Modal', 'ConfirmRemove'), options: {
                            center: true,
                            className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                            show: this.state.isRemoveModalOpen,
                            showClose: true,
                            size: ModalProps_1.ModalSizes.MEDIUM,
                        }, events: {
                            onClose: function () {
                                _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
                                _this.toggleRemoveModal();
                            },
                        } }, React.createElement(RemoveModalContent_1.default, { testId: utils_1.default('Business', 'RemoveModalContent', 'ConfirmRemove'), events: {
                            onCancelClick: function () {
                                _this.toggleRemoveModal();
                            },
                            onRemoveClick: function () {
                                _this.toggleRemoveModal(true);
                            },
                        }, data: {
                            currentLOB: 'BUSINESSAPPS',
                            isBundleinCart: Utils.isBundleinCart().isBundleWithoutAccessory,
                            isSonosinCart: Utils.IsSONOSAccessoryInCart(),
                        } }))),
                React.createElement("div", { className: !this.props.data.isStandaloneBusiness ?
                        localStyles.solidLineLightGrayBottom : '' }),
                React.createElement("div", { className: businessStandaloneStyle },
                    React.createElement("span", { className: localStyles.strongCart }, "Business Tools"),
                    React.createElement("div", null, this.getPlanLineItem(businessPackage, this.numberOfKeys))))));
    };
    // tslint:disable-next-line: no-any
    BusinessTools.prototype.buildCartViewPanelData = function () {
        return {
            dueTodayPrice: this.dueTodayPrice,
            lineOfBusinessName: 'Business Tools',
            removeItemsLinkLabel: 'Remove Business',
        };
    };
    BusinessTools.prototype.initializeEvents = function () {
        var _this = this;
        this.cartViewEvents = {
            onEdit: function () {
                if (_this.props.data.isStandaloneBusiness) {
                    _this.props.events.onEdit('BUSINESSAPPCART', _this.cartMetaData.editUrl);
                }
                else {
                    _this.redirectToBuyFlow(_this.cartMetaData.editUrl);
                }
            },
            onRemove: this.toggleRemoveModal.bind(this),
        };
    };
    BusinessTools.prototype.toggleRemoveModal = function (onlyPageLoadOnRemove) {
        var _this = this;
        this.setState({ isRemoveModalOpen: !this.state.isRemoveModalOpen }, function () {
            if (onlyPageLoadOnRemove) {
                _this.onCartRemove();
            }
            else if (_this.state.isRemoveModalOpen) {
                _this.reportingService.fireLinkClickWithOutPageLoad('Remove Business', ReportingService_1.PageUrls.REMOVE_ALL_ITEMS_MODAL);
                _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.REMOVE_ALL_ITEMS_MODAL);
            }
            else {
                _this.reportingService.fireLinkClickWithOutPageLoad('Close', ReportingService_1.PageUrls.REMOVE_ALL_ITEMS_MODAL);
                _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
            }
        });
    };
    BusinessTools.prototype.onCartRemove = function () {
        var _this = this;
        this.props.events.doLoading(true);
        var editLink = Utils.getEditLinkUrl(this.cartMetaData.editUrl);
        this.stateManager.set('editLinkUrl', { url: editLink });
        var isBundleCart = Utils.isBundleinCart().isBundleWithoutAccessory;
        this.reportingService.reportSystemEventForSelectedAction(false, '-2', 'Remove', isBundleCart ? ReportingService_1.EventTypesCodes.REMOVE_CART_SUBMIT_EVENT :
            ReportingService_1.EventTypesCodes.EMPTY_CART_SUBMIT_EVENT, ReportingService_1.PageUrls.CART_PAGE, ReportingService_1.EventTypesCodes.FORM_SUBMIT_EVENT, undefined);
        this.api.emptyAnyLOBCart('BUSINESSAPPS').then(function (data) {
            if (data.content.status === 'success') {
                _this.reportingService.reportSystemEventForSelectedAction(false, '0', 'Remove', isBundleCart ? ReportingService_1.EventTypesCodes.REMOVE_CART_SUBMIT_EVENT :
                    ReportingService_1.EventTypesCodes.EMPTY_CART_SUBMIT_EVENT, ReportingService_1.PageUrls.CART_PAGE, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, undefined);
                Utils.onCartRemoveLob(true);
                cartUtils.checkCartRedirectionAfterRemove(data);
            }
            else {
                _this.reportingService.reportSystemEventForSelectedAction(true, undefined, 'Remove', isBundleCart ? ReportingService_1.EventTypesCodes.REMOVE_CART_SUBMIT_EVENT :
                    ReportingService_1.EventTypesCodes.EMPTY_CART_SUBMIT_EVENT, ReportingService_1.PageUrls.CART_PAGE, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, "'Error in remvoing cart: '\n                " + JSON.stringify(data));
                _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
            }
            _this.props.events.doLoading(false);
        }).catch(function (err) {
            _this.props.events.doLoading(false);
            _this.toggleRemoveModal();
        });
    };
    BusinessTools.prototype.getPlanLineItem = function (pLineItem, numberOfKeys) {
        return pLineItem.map(function (element) {
            var pkgPrice = 0;
            if (element.price) {
                pkgPrice = element.price.baseAmount ? (element.price.baseAmount) : 0;
            }
            var displayLicenses = "Licenses: " + (element === null || element === void 0 ? void 0 : element.quantity);
            return (React.createElement("div", { key: "lineItem_" + element.id, id: "lineItem_" + element.id },
                React.createElement("div", null,
                    React.createElement("div", { className: localStyles.lineItemPlanContainer },
                        React.createElement("div", { className: localStyles.lineItemName },
                            React.createElement("div", { id: utils_1.default('business', 'Label', 'LineItem'), className: "" },
                                React.createElement(ui_components_1.RichText, { testId: utils_1.default('business', 'Label', 'LineItem'), data: { text: element.displayName } })),
                            React.createElement("div", null,
                                React.createElement(ui_components_1.RichText, { testId: utils_1.default('business', 'Label', 'Subscription'), data: { text: displayLicenses } }))),
                        React.createElement("div", { className: localStyles.lineItemPrice }, element.price &&
                            React.createElement("div", null,
                                React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('Business', 'PriceContainer', 'LineItem'), data: {
                                        billingNote: (element.price.priceType === 'RC') ? '/mo.' : '',
                                        price: pkgPrice,
                                    }, options: {
                                        className: localStyles.lineItem,
                                        decimalPoints: 2,
                                        type: PriceContainerProps_1.PricingType.XSMALL,
                                    } })))))));
        });
    };
    BusinessTools.prototype.redirectToBuyFlow = function (editLinkUrl) {
        var editLink = Utils.getEditLinkUrl(editLinkUrl);
        this.reportingService.fireLinkClickWithOutPageLoad('Edit', editLink);
        this.stateManager.set('editLinkUrl', { url: editLink });
        this.stateManager.set('CurrentPageURL', { name: editLink });
        if (typeof window !== undefined) {
            window.location.href = '/buy' + editLink;
        }
        else {
            routables_1.history.push(editLink);
        }
    };
    return BusinessTools;
}(React.Component));
exports.default = BusinessTools;
//# sourceMappingURL=BusinessTools.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/BusinessTools/BusinessTools.js
// module id = 2320
// module chunks = 8